/** @jsx jsx */
import { Flex, jsx } from 'theme-ui';

import { PreviousSlideIcon, NextSlideIcon } from '../../images/icons';

const RenderNextPrevCaptionIcons = ({ sliderRef }) => {
  return (
    <Flex sx={sliderTrigger}>
      <button sx={sliderTrigger.button} onClick={sliderRef.slickPrev}>
        <PreviousSlideIcon />
      </button>
      <button sx={sliderTrigger.button} onClick={sliderRef.slickNext}>
        <NextSlideIcon />
      </button>
    </Flex>
  );
};

const sliderTrigger = {
  button: {
    variant: 'styles.btnReset',
    p: 3,
    mx: 3,
  },
};

export default RenderNextPrevCaptionIcons;
